<template>
  <div>
    <!--
      Need to use v-if here instead of CSS to prevent the
      component and its children (including slot) from mounting
      and potentially making many API requests
    -->
    <platforms-accordion
      v-if="$q.screen.lt.md"
      :platforms="platforms"
      :model-value="modelValue"
      @loaded="$emit( 'loaded', $event)"
      @update:model-value="$emit('update:modelValue', $event)"
    >
      <template v-slot:header="scope">
        <slot name="header" v-bind="scope" />
      </template>
      <slot />
    </platforms-accordion>
    <div v-else class="row">
      <div class="col-4">
        <platforms-list
          :platforms="platforms"
          :model-value="modelValue"
          class="full-height"
          @loaded="$emit( 'loaded', $event)"
          @update:model-value="$emit('update:modelValue', $event)"
        >
          <template v-slot="scope">
            <slot name="header" v-bind="scope" />
          </template>
        </platforms-list>
      </div>
      <div class="col-8">
        <slot v-bind="{ isSplit : true }" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Platform } from '@/social/types';
import PlatformsAccordion from './PlatformsAccordion.vue';
import PlatformsList from './PlatformsList.vue';

export default defineComponent({
  emits: ['loaded', 'update:modelValue'],
  components: {
    PlatformsAccordion,
    PlatformsList,
  },
  props: {
    platforms: {
      type: Array as () => Platform[],
      default: () => [],
    },
    modelValue: Object as () => Platform,
  },
});
</script>
